"use client";

import { c as _c } from "react/compiler-runtime";
import ImageComponent from "@/components/ui/image";
import { ArrowRight } from "lucide-react";
import HeroMain from "@/assets/images/v2/hero-main.webp";
import { sendGAEvent } from "@next/third-parties/google";
import { cn } from "@/utils/utils";
import Link from "next/link";
import GiftsForHerImg from "@/assets/images/v2/gifts_for_her.webp";
import GiftsForHimImg from "@/assets/images/v2/gifts_for_him.webp";
import GiftsForKidsImg from "@/assets/images/v2/gifts_for_kids.webp";
const GiftsForHerSection = () => {
  const $ = _c(17);
  const handleCollectionClick = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="font-outfit tracking-[0.3em] uppercase text-center text-[10px] text-v2-primary/70 font-semibold">Artisan Collective</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className={cn("tracking-tight md:tracking-normal not-italic md:italic font-bold md:font-normal", "md:hidden")}>Meaningful Relationships</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-center mb-12">{t0}<h3 className="text-center font-lora text-v2-primary mb-2 md:mb-4 text-2xl md:text-4xl lg:text-5xl italic md:not-italic font-extralight md:font-semibold leading-8 md:leading-[1.25] lg:leading-none">{t1}<span className="hidden md:inline"><span className="tracking-tight md:tracking-normal not-italic md:italic font-bold md:font-normal">Meaningful</span>{" "}Relationships</span></h3><p className="font-outfit font-normal text-sm text-v2-on-surface-variant/80 uppercase tracking-widest mt-2">Gifts For the Ones You Love</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => handleCollectionClick("For Her");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="w-full aspect-[4/5] bg-v2-surface-container-lowest overflow-hidden relative"><ImageComponent src={GiftsForHerImg} alt="Gifts For Her" fill={true} className="object-cover object-center transform group-hover:scale-105 transition-transform duration-700 w-full h-full" fallbackSrc={HeroMain} /></div>;
    t5 = <div className="absolute inset-0 bg-gradient-to-t from-v2-on-surface/60 via-transparent to-transparent opacity-40 group-hover:opacity-100 transition-opacity duration-500" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="/listing/the-best-of-gifts?id=5" className="relative group cursor-pointer overflow-hidden rounded-lg shadow-xl md:max-w-2xl lg:max-w-3xl mx-auto block" onClick={t3}>{t4}{t5}<div className="absolute inset-x-0 bottom-12 flex justify-center px-6 z-20"><div className="w-full max-w-sm shadow-2xl border border-v2-primary/30 rounded-xl p-4 md:p-8 flex flex-col items-center text-center group-hover:scale-[1.02] transition-transform duration-500"><div className="flex items-center gap-3 mb-6"><h4 className="font-lora text-4xl text-white tracking-tight whitespace-nowrap drop-shadow-lg">For Her</h4></div><p className="font-outfit text-[11px] min-[375px]:text-xs md:text-sm text-white mb-6 -mt-4 tracking-wide whitespace-nowrap drop-shadow-md">Not just a gift. A story she gets to keep</p><div className="w-auto mx-auto block bg-v2-primary-container text-v2-on-primary px-6 md:px-8 py-2 rounded-full font-outfit text-sm font-medium uppercase tracking-widest md:tracking-[0.2em] shadow-lg shadow-v2-primary/20 active:scale-95 transition-all whitespace-nowrap">Shop Collection</div></div></div></Link>;
    t7 = <div className="hidden" />;
    t8 = <div className="hidden" />;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => handleCollectionClick("For Him");
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ImageComponent src={GiftsForHimImg} alt="Gifts for Friends" fill={true} className="object-cover object-center transform scale-[1.3] group-hover:scale-[1.35] transition-transform duration-700 w-full h-full" fallbackSrc={HeroMain} />;
    t11 = <div className="absolute inset-0 bg-gradient-to-t from-v2-on-surface/60 via-transparent to-transparent opacity-40 group-hover:opacity-100 transition-opacity duration-500" />;
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Link href="/listing/gifts-for-him?id=29" className="relative group cursor-pointer flex-1 block" onClick={t9}><div className="bg-v2-surface-container-lowest rounded-lg overflow-hidden relative"><div className="h-48 relative overflow-hidden">{t10}{t11}<div className="absolute inset-x-0 bottom-4 flex justify-center px-2 md:px-4 z-20"><div className="w-full shadow-xl border border-v2-primary/30 rounded-xl py-2 px-2 md:px-4 flex flex-col items-center text-center group-hover:scale-[1.02] transition-transform duration-500"><div className="flex items-center gap-1 md:gap-2"><h4 className="font-lora text-xl md:text-2xl text-white tracking-tight whitespace-nowrap drop-shadow-lg">For Him</h4><ArrowRight className="size-4 md:size-5 text-white transition-transform duration-300 group-hover:translate-x-1 shrink-0 drop-shadow-lg" strokeWidth={2.5} /></div></div></div></div></div></Link>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => handleCollectionClick("For Kids");
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ImageComponent src={GiftsForKidsImg} alt="For Kids" fill={true} className="object-cover object-center transform group-hover:scale-105 transition-transform duration-700 w-full h-full" fallbackSrc={HeroMain} />;
    t15 = <div className="absolute inset-0 bg-gradient-to-t from-v2-on-surface/60 via-transparent to-transparent opacity-40 group-hover:opacity-100 transition-opacity duration-500" />;
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <section className="block md:hidden py-10 px-6 bg-v2-surface"><div className="max-w-[1440px] mx-auto">{t2}<div className="flex flex-col gap-12">{t6}{t7}{t8}<div className="flex gap-2 mt-[-1rem]">{t12}<Link href="/listing/gifts-for-kids?id=37" className="relative group cursor-pointer flex-1 block" onClick={t13}><div className="bg-v2-surface-container-lowest rounded-lg overflow-hidden relative"><div className="h-48 relative overflow-hidden">{t14}{t15}<div className="absolute inset-x-0 bottom-4 flex justify-center px-2 md:px-4 z-20"><div className="w-full shadow-xl border border-v2-primary/30 rounded-xl py-2 px-2 md:px-4 flex flex-col items-center text-center group-hover:scale-[1.02] transition-transform duration-500"><div className="flex items-center gap-1 md:gap-2"><h4 className="font-lora text-xl md:text-2xl text-white tracking-tight whitespace-nowrap drop-shadow-lg">For Kids</h4><ArrowRight className="size-4 md:size-5 text-white transition-transform duration-300 group-hover:translate-x-1 shrink-0" strokeWidth={2.5} /></div></div></div></div></div></Link></div></div></div></section>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  return t16;
};
export default GiftsForHerSection;
function _temp(collectionName) {
  const formattedName = collectionName.toLowerCase().replace(/ /g, "_");
  sendGAEvent("event", `show_more_${formattedName}_clicked`);
}